import { VEHICLE_STATUS_LABELS } from "../constants";

export type VehicleSituation = keyof typeof VEHICLE_STATUS_LABELS;

export const vehicleSituationLabel = (situation: VehicleSituation) =>
	VEHICLE_STATUS_LABELS[situation];
